// NATIVE 

// INSTALLED 

// CUSTOM 
import { types } from '../../commons/types/types';
import { loginWithEmailPassword } from '../../services';
import { checkingPreload, unCheckingPreload } from '../loading';
import { ILoginWithEmailPassword } from '../../commons/interfaces';
import { setPermissions, setUserPermissions } from '../permissions';
import { setNotificationsList } from './notificationsSlice';
import { markOneAsReadService } from '../../services/notifications.service';




export const markOneAsReadStore = (notificationId:string): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      


      const result = await  markOneAsReadService(notificationId);


    //   if ( result.ok ) {
    //       await dispatch( setNotificationsList(result.data) );
    //   }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}